import React from "react";

import { CloseOvalIcon as CloseIcon } from "assets";
import "./CloseIconSvg.scss";

const DEFAULT_SIZE = 25;

export interface ICloseIconSvgProps {
  size?: number;
}

export const CloseIconSvg: React.FC<React.PropsWithChildren<ICloseIconSvgProps>> = ({
  size = DEFAULT_SIZE,
}) => {
  return (
    <CloseIcon
      height={size}
      width={size}
      aria-label="close"
      tabIndex={0}
      className="c-close-icon"
    />
  );
};
